import React from "react";
import { Analytics } from "@vercel/analytics/react"
import MainSection from "@/components/MainSection";
import SocialLink from "@/components/SocialLink";
import { portfolioData } from "@/data/portfolio";
import TargetCursor from "@/components/TargetCursor.tsx";

const App: React.FC = () => {
  const { personalInfo, socialLinks, skillSections } = portfolioData;

  return (
    <>
        <TargetCursor
            spinDuration={4}
            hideDefaultCursor={true}
        />
      <main className="min-h-screen flex flex-col items-center justify-center p-8 dark:bg-[#101218] bg-[#F4F4F4] dark:text-[rgb(238,240,255)] text-[rgb(0,29,53)]">
      <h1 className="font-megrim text-5xl md:text-7xl text-center mb-8">
          {personalInfo.name}<br /> 
          {personalInfo.title}
        </h1>
        
        <div className="flex gap-8 mb-20 w-2/4 justify-evenly">
          {socialLinks.map((socialLink, index) => (
            <SocialLink key={index} socialLink={socialLink} />
          ))}
        </div>
        
        <div className="w-full max-w-6xl grid grid-cols-1 md:grid-cols-3 gap-8">
          {skillSections.map((skillSection, index) => (
            <MainSection key={index} skillSection={skillSection} />
          ))}
        </div>
      </main>
      <Analytics />
    </>
  );
}

export default App;
